export const API_URL = process.env.REACT_APP_API_URL || window.REACT_APP_API_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || window.REACT_APP_GOOGLE_CLIENT_ID;
export const AUTH_COOKIE_NAME = process.env.REACT_APP_AUTH_COOKIE_NAME || window.REACT_APP_AUTH_COOKIE_NAME;
